import clsx from 'clsx';
import React from 'react';

class card {
  Container: React.FC = ({ children }) => (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-10">
      {' '}
      {children}
    </div>
  );
  Heading: React.FC = ({ children }) => (
    <div className="bg-white px-4 py-5 sm:px-6">
      <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
        {children}
      </div>
    </div>
  );

  HeadingLeft: React.FC = ({ children }) => (
    <div className="ml-4 mt-4">
      <div className="flex items-center">{children}</div>
    </div>
  );
  HeadingRight: React.FC = ({ children }) => (
    <div className="ml-4 mt-4 flex-shrink-0 flex">{children}</div>
  );
  Field: React.FC<{ col?: boolean }> = ({ children, col }) => (
    <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
      <dl className="sm:divide-y sm:divide-gray-200">
        <div
          className={clsx({
            'py-4 sm:py-5 sm:grid sm:px-6': true,
            'sm:grid-cols-3 sm:gap-4': !col,
          })}
        >
          {children}
        </div>
      </dl>
    </div>
  );
  Dt: React.FC = ({ children }) => (
    <dt className="text-sm font-medium text-gray-500">{children}</dt>
  );
  Dd: React.FC = ({ children }) => (
    <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
      {children}
    </dd>
  );
}

const Card = new card();

export default Card;
